import tw, { styled } from "twin.macro"

export const Wrapper = styled.nav`
  ${tw`fixed inset-y-0 left-0 h-full bg-white w-full md:w-1/2 flex flex-col overflow-y-scroll overflow-x-hidden xl:hidden transform transition-all duration-300 z-50`}
  ${({ active }) => (active ? tw`pointer-events-auto visible opacity-100 translate-x-0` : tw`pointer-events-none invisible opacity-0 -translate-x-100`)}
`

export const Close = tw.button``